import { render } from "./dining.vue?vue&type=template&id=3f1d9a7f&scoped=true"
import script from "./dining.vue?vue&type=script&lang=js"
export * from "./dining.vue?vue&type=script&lang=js"

import "./dining.vue?vue&type=style&index=0&id=3f1d9a7f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f1d9a7f"

export default script